import React from "react";
import "./line.css";

const Separator = () => {
  return <hr className="separator"></hr>;
};

export default Separator;
